import { createPortal } from "react-dom";
import { Toast } from "./Toast";

interface ToastItem {
  id: string;
  message: string;
  variant: "success" | "error" | "info";
}

interface ToasterProps {
  toasts: ToastItem[];
  onDismiss: (id: string) => void;
}

export function Toaster({ toasts, onDismiss }: ToasterProps) {
  return createPortal(
    <div
      aria-label="Notifications"
      className="fixed top-4 right-4 z-50 flex flex-col gap-2 w-full max-w-sm"
    >
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          message={toast.message}
          variant={toast.variant}
          onDismiss={onDismiss}
        />
      ))}
    </div>,
    document.body
  );
}
